/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_No_Matches_DescriptionInputs */



/**
* | output |
* | --- |
* | "Try a different search, or clear the category filter." |
*
* @param {My_Integrations_No_Matches_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_no_matches_description = /** @type {((inputs?: My_Integrations_No_Matches_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_No_Matches_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Versuchen Sie eine andere Suche oder setzen Sie den Kategoriefilter zurück.")
	return /** @type {LocalizedString} */ ("Try a different search, or clear the category filter.")
});